import { Component } from '@angular/core';

@Component({
  selector: 'app-route-wrapper',
  template: `<router-outlet></router-outlet>`,
  standalone: false,
})
export class RouteWrapperComponent {}
